

export class AlertAddInput implements IAlertAddInput {
    /** The alert name with 255 character limit */
    alertName!: string;

    constructor(data?: IAlertAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertName = _data["alertName"];
        }
    }

    static fromJS(data: any): AlertAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertName"] = this.alertName;
        return data; 
    }
}

export interface IAlertAddInput {
    /** The alert name with 255 character limit */
    alertName: string;
}

